import React from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'

import {
   Button,
   DashboardLayout,
   Icon,
   InputGroup,
   Loader,
   Modal,
   Select,
   Tabs,
   WsnToast
} from '../../components'
import Coin from './Coin'

import './Exchange.scss'
import Settings from './Settings'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllCoins } from '../../store/coins'
import { addNotification } from '../../store/notifications'
import { isDesktop } from '../../utils'
import clsx from 'clsx'
import { Popover } from 'react-tiny-popover'
import CustomToken from './CustomToken'

const Exchange = () => {
   const TABS = ['Market']//['Market', 'Limit']
   const TIME_OPTIONS = [
      { title: '10 minutes', value: 10 },
      { title: '1 Hour', value: 60 },
      { title: '3 Days', value: 60 * 24 * 3 },
   ]
   const isDesktopScreen = isDesktop()

   const dispatch = useDispatch()
   const { allCoins, isLoading } = useSelector(state => state.coins)
   const { isDarkTheme } = useSelector(state => state.theme)
   const { privateKey } = useSelector(state => state.user)

   React.useEffect(() => {
      if (allCoins.length) {
         setCoins(allCoins)
         setFrom(allCoins[0])
         setTo(allCoins[1])
         setTransactionCost(2.6)
         getQuote()
      } else {
         dispatch(fetchAllCoins())
      }
   }, [allCoins, allCoins.length, dispatch])

   const [currentTab, setCurrentTab] = React.useState(TABS[0])
   const [isSettingsVisible, setIsSettingsVisible] = React.useState(false)
   const [coins, setCoins] = React.useState([])
   const [isTokenPopoverOpen, setIsTokenPopoverOpen] = React.useState(false)
   const [isTokenModalVisible, setIsTokenModalVisible] = React.useState(false)
   const [tokenAddress, setTokenAddress] = React.useState('')

   const [transactionFlag, setTransactionFlag] = React.useState(false)
   const [from, setFrom] = React.useState({})
   const [to, setTo] = React.useState({})
   const [value, setValue] = React.useState(1)
   const [transactionCost, setTransactionCost] = React.useState(0)
   const [limitPrice, setLimitPrice] = React.useState(16.5)
   const [expiry, setExpiry] = React.useState(TIME_OPTIONS[0])
   const [isPartialFill, setIsPartialFill] = React.useState(false)
   const [isCHIToken, setIsCHIToken] = React.useState(false)
   const [isOptimizedRouter, setIsOptimizedRouter] = React.useState(false)
   const [slippageTolerence, setSlippageTolerence] = React.useState(null)
   const [gasPrice, setGasPrice] = React.useState(null)
   const [customTokens, setCustomTokens] = React.useState([
      {
         id: 1,
         name: 'TOMOChain',
         unit: 'TOMO',
         value: 1500,
         image: 'https://via.placeholder.com/32',
      },
   ])

   const getQuote = async () => {
      const response = await axios.get(`https://api.1inch.exchange/v3.0/56/quote?fromTokenAddress=${from['address']}&toTokenAddress=${to['address']}&amount=${value * 10 ** from['decimals']}`)
      setTransactionCost(response.data.estimatedGas)
   }

   const swapTokens = async () => {
      // console.log('here')
      // console.log(from['address'])
      // console.log(to['address'])
      // console.log(from['decimals'])
      // console.log(privateKey)
      setTransactionFlag(true)
      const fromToken = from['unit']
      const toToken = to['unit']
      try{
         let response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/swap/swap`,
            {
               privateKey: privateKey,
               fromAddress: from['address'],
               toAddress: to['address'],
               amount: value * 10 ** from['decimals'],
               value: value
            }
         )
         console.log(response)
         const heading = 'Transaction receipt!'
         const description = `Swap ${fromToken} to ${toToken}`
   
         dispatch(addNotification({ heading, description }))
         // url is optional
         toast(
            <WsnToast
               heading={heading}
               message={description}
               url={'https://bscscan.com/tx/' + response.data.data.hash}
            />
         )
      } catch{
         const heading = 'Transaction Failed!'
         const description = `Swap ${fromToken} to ${toToken}`
   
         dispatch(addNotification({ heading, description }))
         // url is optional
         toast(
            <WsnToast
               heading={heading}
               message={description}
            />
         )
      }
      setTransactionFlag(false)
   }

   const renderInfo = () => {
      if (currentTab === TABS[0]) {
         // market
         return (
            <>
               <div className="Exchange__main-card-info">
                  <p className="Exchange__main-card-info-key">Sell Price</p>
                  <p className="Exchange__main-card-info-value">
                     1 {from.unit} ={' '}
                     <span className="Exchange__main-card-info-value-highlight">
                        {(from.valueInUsd/to.valueInUsd).toFixed(6)}
                     </span>{' '}
                     {to.unit}
                  </p>
               </div>
               <div className="Exchange__main-card-help-text">
                  {from.valueInUsd}
               </div>
               <div className="Exchange__main-card-info">
                  <p className="Exchange__main-card-info-key">Buy Price</p>
                  <p className="Exchange__main-card-info-value">
                     1 {to.unit} ={' '}
                     <span className="Exchange__main-card-info-value-highlight">
                        {(to.valueInUsd/from.valueInUsd).toFixed(6)}
                     </span>{' '}
                     {from.unit}
                  </p>
               </div>
               <div className="Exchange__main-card-help-text">
                  {to.valueInUsd}
               </div>
               <div className="Exchange__main-card-info">
                  <p className="Exchange__main-card-info-key">
                     Transaction Cost
                  </p>
                  <p className="Exchange__main-card-info-value">
                     {transactionCost}
                  </p>
               </div>
               <div className="Exchange__main-card-help-text">
                  {(from.value / from.valueInUsd) * transactionCost}
               </div>
            </>
         )
      } else {
         // limit
         return (
            <>
               <div className="Exchange__main-card-info">
                  <p className="Exchange__main-card-info-key">Rate</p>
                  <p className="Exchange__main-card-info-value">
                     1 {from.unit} ={' '}
                     <span className="Exchange__main-card-info-value-highlight">
                        {to.value}
                     </span>{' '}
                     {to.unit}
                  </p>
               </div>
               <div className="Exchange__main-card-info">
                  <p className="Exchange__main-card-info-key">Inversion Rate</p>
                  <p className="Exchange__main-card-info-value">
                     1 {to.unit} ={' '}
                     <span className="Exchange__main-card-info-value-highlight">
                        {from.value}
                     </span>{' '}
                     {from.unit}
                  </p>
               </div>
            </>
         )
      }
   }

   const renderCTAs = () => {
      if (currentTab === TABS[0]) {
         // market
         if(transactionFlag){
            return (
               <Button
                  variant="solid"
                  color="gray"
                  className={clsx(
                     'Exchange__cta',
                     isDesktopScreen && 'Exchange__cta--desktop'
                  )}
                  size={isDesktopScreen ? 'lg' : undefined}
                  isDarkTheme={isDarkTheme}
               >
                  Swap
               </Button>
            )
         } else{
            return (
               <Button
                  variant="solid"
                  color="primary"
                  className={clsx(
                     'Exchange__cta',
                     isDesktopScreen && 'Exchange__cta--desktop'
                  )}
                  onClick={() => swapTokens()}
                  size={isDesktopScreen ? 'lg' : undefined}
                  isDarkTheme={isDarkTheme}
               >
                  Swap
               </Button>
            )
         }
      } else {
         // limit
         return (
            <>
               <Button
                  variant="solid"
                  color="primary"
                  className={clsx(
                     'Exchange__cta',
                     isDesktopScreen && 'Exchange__cta--desktop'
                  )}
                  size={isDesktopScreen ? 'lg' : undefined}
                  isDarkTheme={isDarkTheme}
               >
                  Give Permission
               </Button>
               <Button
                  variant="outline"
                  color="primary"
                  className={clsx(
                     'Exchange__cta',
                     isDesktopScreen && 'Exchange__cta--desktop'
                  )}
                  size={isDesktopScreen ? 'lg' : undefined}
                  isDarkTheme={isDarkTheme}
               >
                  Review Limit Order
               </Button>
            </>
         )
      }
   }

   const renderContent = () => {
      return (
         <>
            {isSettingsVisible ? (
               <Settings
                  close={() => setIsSettingsVisible(false)}
                  isLimitOrder={currentTab === TABS[1]}
                  isPartialFill={isPartialFill}
                  setIsPartialFill={setIsPartialFill}
                  isCHIToken={isCHIToken}
                  setIsCHIToken={setIsCHIToken}
                  isOptimizedRouter={isOptimizedRouter}
                  setIsOptimizedRouter={setIsOptimizedRouter}
                  slippageTolerence={slippageTolerence}
                  setSlippageTolerence={setSlippageTolerence}
                  gasPrice={gasPrice}
                  setGasPrice={setGasPrice}
                  customTokens={customTokens}
                  setCustomTokens={setCustomTokens}
               />
            ) : (
               <>
                  <div
                     className={clsx(
                        'Exchange__main',
                        isDesktopScreen && 'Exchange__main--desktop',
                        isDarkTheme && 'Exchange__main--dark'
                     )}
                  >
                     <div className="Exchange__main-header">
                        <Tabs
                           className="Exchange__main-header-tabs"
                           options={TABS}
                           current={currentTab}
                           onTabChange={newTab => setCurrentTab(newTab)}
                           isDarkTheme={isDarkTheme}
                        />
                        <div className="Exchange__main-header-actions">
                           <Icon
                              className="Exchange__main-header-actions-icon"
                              name="refresh"
                           />
                           <Popover
                              isOpen={isTokenPopoverOpen}
                              positions={['bottom', 'right', 'left', 'top']}
                              onClickOutside={() =>
                                 setIsTokenPopoverOpen(false)
                              }
                              content={
                                 <CustomToken
                                    inPopover={true}
                                    value={tokenAddress}
                                    setValue={setTokenAddress}
                                    onAdd={() => console.log('Add token!')}
                                 />
                              }
                           >
                              <Icon
                                 className="Exchange__main-header-actions-icon"
                                 name="outline-plus"
                                 onClick={() =>
                                    isDesktop()
                                       ? setIsTokenPopoverOpen(
                                            !isTokenPopoverOpen
                                         )
                                       : setIsTokenModalVisible(true)
                                 }
                              />
                           </Popover>
                           <Icon
                              className="Exchange__main-header-actions-icon"
                              name="settings"
                              onClick={() => setIsSettingsVisible(true)}
                           />
                        </div>
                     </div>
                     <Coin
                        className="Exchange__main-from"
                        isDarkTheme={isDarkTheme}
                        label="You Pay"
                        {...from}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        coins={coins.filter(coin => coin.unit !== to?.unit)}
                        onCoinSelect={coin => {
                           setFrom({
                              ...from,
                              ...coin,
                           })
                           getQuote()
                        }}
                     />
                     {currentTab === TABS[1] && (
                        <div className="Exchange__main-limit">
                           <InputGroup
                              value={limitPrice}
                              onChange={e => setLimitPrice(e.target.value)}
                              type="number"
                              label="Price"
                              className="Exchange__main-limit-input"
                              right={from.unit}
                              isDarkTheme={isDarkTheme}
                           />
                           <div className="Exchange__main-limit-expiry-wrapper">
                              <div className="Exchange__main-limit-expiry-label">
                                 Expires In
                              </div>
                              <Select
                                 className={clsx(
                                    'Exchange__main-limit-expiry',
                                    isDarkTheme &&
                                       'Exchange__main-limit-expiry--dark'
                                 )}
                                 current={expiry}
                                 onChange={selectedOption =>
                                    setExpiry(selectedOption)
                                 }
                                 options={TIME_OPTIONS}
                                 isDarkTheme={isDarkTheme}
                              />
                           </div>
                        </div>
                     )}
                     <Icon className="Exchange__main-icon" name="fa-exchange" />
                     <Coin
                        className="Exchange__main-to"
                        isDarkTheme={isDarkTheme}
                        label="You Receive"
                        {...to}
                        coins={coins.filter(coin => coin.unit !== from?.unit)}
                        onCoinSelect={coin => {
                           setTo({
                              ...to,
                              ...coin,
                           })
                           getQuote()
                        }}
                     />
                     <div className="Exchange__main-card">{renderInfo()}</div>
                  </div>
                  {renderCTAs()}
                  <Modal
                     isOpen={isTokenModalVisible}
                     close={() => setIsTokenModalVisible(false)}
                     heading="Add Custom Token"
                     isDarkTheme={isDarkTheme}
                  >
                     <CustomToken
                        value={tokenAddress}
                        setValue={setTokenAddress}
                     />
                  </Modal>
               </>
            )}
         </>
      )
   }

   if (isDesktopScreen) {
      return (
         <DashboardLayout>
            <div
               className={clsx(
                  'DesktopExchange',
                  isDarkTheme && 'DesktopExchange--dark'
               )}
            >
               {isLoading ? (
                  <Loader isDarkTheme={isDarkTheme} />
               ) : (
                  <div className="DesktopExchange__card">{renderContent()}</div>
               )}
            </div>
         </DashboardLayout>
      )
   }
   return (
      <DashboardLayout className="Exchange">
         <header className="Exchange__header">
            <h1 className="Exchange__header-heading">Exchange</h1>
         </header>

         {isLoading ? <Loader isDarkTheme={isDarkTheme} /> : renderContent()}
      </DashboardLayout>
   )
}

export default Exchange
